module.exports = __webpack_public_path__ + "img/background_logo_1.d69c1851.svg";